<template>
  
    <div class="flex flex-row justify-center">
        
        <div class="mt-1">

            <!-- Sessions.vue has it is own search implementation-->
            
            <div v-if="name != ''" class="mb-2">

                <label class="font-bold">{{$t('search.search')}} {{name}}</label>
            </div>
            <div>

            <input v-model="searchInput" @input="doSearch"
                class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg
                block appearance-none leading-normal text-center w-40 lg:w-64" placeholder="search">
            </div>

             <div v-if="showLoader">
    
                <ring-loader ></ring-loader> 
            </div>
        </div>
    </div>
</template>

<script>

export default {

    props:{

        name: '',

        myList:{

            type: Array,
        },

        sendResultsTo:{

            type: Function
        }
    },
    
     methods: {

         created(){

            //  console.log(`list is ${JSON.stringify(this.myList)}`)
         },

        doSearch(){

            let saveSearchResultsMethod = this.saveSearchResults; 
            
            // let text = JSON.stringify(this.list);
            // this.$search(this.searchInput, this.instructor, { options }).then(results => {

            if(this.searchInput == ''){
                
                saveSearchResultsMethod(this.myList);
                
                // console.log(`myList are: ${JSON.stringify(this.myList)}`);

                return;
            }
            // console.log(`variables are: ${this.searchInput} and ${JSON.stringify(this.myList)}`) 

            this.$search(this.searchInput, this.myList, this.options).then(results => {
            
            // console.log(`results are: ${JSON.stringify(results)}`);
            
            saveSearchResultsMethod(results);
            });
        },

        saveSearchResults(results){

            this.SearchResults = results;

            this.sendResultsTo(this.SearchResults);
        }
    },

    data: function(){

        return{

            
            SearchResults: '',
            showLoader: false,
            //https://fusejs.io/api/options.html#basic-options
            searchInput:'',
            options: {
            isCaseSensitive: false,
            findAllMatches: true,
            includeMatches: false,
            includeScore: false,
            useExtendedSearch: false,
            minMatchCharLength: 1,
            shouldSort: true,
            threshold: 0.1,
            location: 0,
            distance: 100,
            keys: [
                // "title",
                "name"
            ]},
        }
    }

}
</script>

<style>

</style>